import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import Input from '../../../../components/form/Input';
import Button from '../../../../components/form/Button';
import CroField from '../../components/generalForm/CroField';
import CroLabeledCmp from '../../components/generalForm/CroLabeledCmp';
import MultiSelect from '../../../../components/form/MultiSelect';
import { styles } from '../../index';
import * as V from '../../../../utils/formValidation';

class ForwardInitiativeForm extends Component {
    componentWillMount() {
        this.props.breadcrumbs(this.props.breadcrumbsItems);
    }

    render() {
        const { error, onSubmit, handleSubmit, goBack, submitting, dispatch } = this.props;
        return (
            <form onSubmit={handleSubmit(onSubmit)} className="cro-form initiativeForm">
                <div className="initiativeForm__section">
                    <div className="initiativeForm__grid">
                        <Field name="id" type="hidden" component="input" style={{ display: 'none' }} />
                        <CroField title="Organizace" name="organization" component={Input} fullWidth validate={[V.required]} maxlen={3000} />
                        <CroField
                            title="Důvod postoupení"
                            name="forwardingReasons"
                            component={MultiSelect}
                            url="/api/ciselniky/k-podstoupeni"
                            dispatch={dispatch}
                            label="Důvod postoupení"
                        />
                        <CroField title="Komentář k postoupení" name="forwardingComment" component={Input} fullWidth multiLine maxlen={3000} />
                    </div>
                </div>
                <div className="initiativeForm__footer no-print">
                    <div className="initiativeForm__footerInner">
                        {error && <div className="error" style={{ flexBasis: '100%' }}>{error}</div>}
                        <div className="initiativeForm__hint">
                            Povinná pole jsou označena hvězdičkou.
                        </div>

                        <div className="initiativeForm__actions">
                            <Button type="button" style={styles.buttons} label="Postoupit" disabled={submitting} onClick={handleSubmit(onSubmit)} />
                            <Button type="button" style={styles.buttons} label="Zpět" disabled={submitting} onClick={goBack} />
                        </div>
                    </div>
                </div>

            </form>
        );
    }
}

export default reduxForm({
    form: 'forwardInitiativeForm',
})(ForwardInitiativeForm);